import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { isMobile } from 'util/device';
import { useFetchProgress } from 'components/hooks';

import { PODCASTS_PAGE_TITLE } from 'globalConst/const';
import SHOW_MORE from 'globalConst/searchResults-const';

import CONTENT_TYPES from 'globalConst/contentTypes-const';

import { SCHEMA_PAGE_TYPE, SCHEMA_ACTION_TYPE } from 'globalConst/schema-const';
import NotFoundPage from 'components/pages/status/NotFoundPage';
import { BreadcrumbsSchema, PageTypeSchema, PodcastsSchema, DeeplinkSchema } from 'components/Schema';
import PageHeader from 'components/PageHeader';
import PageContent from 'components/PageContent';
import Collection from 'components/Collection';
import { DisplayLayout } from 'components/Collection/Collection.const';
import PodcastLatestEpisode from 'components/PodcastLatestEpisode';
import { TILE_COMPONENT_TYPES } from 'components/TileComponent/TileComponent.const';
import { isEmpty } from 'util/index';

function PodcastPage(props) {
  const { isComponentLoading, error, title, description, slug, tags, mainPodcastImage, author, labels } = props;
  let { episodes } = props;

  const progress = useFetchProgress({
    slug,
    contentTypeId: CONTENT_TYPES.PODCAST,
  });
  if (progress && episodes) {
    episodes = episodes.map((episode) => ({
      ...episode,
      progress: progress[episode.id],
    }));
  }

  const deeplink = [
    {
      type: SCHEMA_ACTION_TYPE.LISTEN_ACTION,
      link: `play/podcast/${slug}/last`,
    },
  ];

  if (!isComponentLoading && error) {
    return <NotFoundPage />;
  }

  const metadata = {
    title,
    description,
    tags,
    labels,
    share: {
      url: window.location.href,
      title,
      description,
      image: mainPodcastImage,
    },
  };
  const rows = isMobile ? SHOW_MORE.PODCASTS.EPISODE_LIMIT : episodes && episodes.length;
  return (
    <Fragment>
      <PageTypeSchema type={SCHEMA_PAGE_TYPE.ITEM_PAGE} metadata={metadata} />
      <DeeplinkSchema deeplinks={deeplink} />
      <PageHeader {...props} isPodcastDetailPage metadata={metadata} />
      <BreadcrumbsSchema level2={PODCASTS_PAGE_TITLE} level3={title} />
      <PageContent>
        {!isMobile && <PodcastLatestEpisode episodes={episodes} />}
        {!isEmpty(episodes) && (
          <Collection
            items={isMobile ? episodes : episodes.slice(1)}
            rows={rows || SHOW_MORE.PODCASTS.DEFAULT_EPISODE_LIMIT}
            display={DisplayLayout.LIST}
            tileComponent={TILE_COMPONENT_TYPES.ON_DEMAND}
            contentTypeId="podcastCollection"
            isComponentLoading={isComponentLoading}
            title={isMobile ? null : 'Afleveringen'}
            showMoreButton={isMobile ? ['button'] : null}
            showMoreLabel={isMobile ? 'Toon meer afleveringen' : null}
            isPodcastPage
          />
        )}

        <PodcastsSchema
          name={title}
          description={description}
          abstract={description}
          id={slug}
          image={mainPodcastImage && mainPodcastImage.url}
          author={author || ''}
          keywords={labels && labels.join()}
          numberOfEpisodes={episodes && episodes.length}
        />
      </PageContent>
    </Fragment>
  );
}

PodcastPage.defaultProps = {
  author: null,
  description: null,
  episodes: null,
  error: false,
  isComponentLoading: false,
  labels: null,
  mainPodcastImage: null,
  slug: null,
  tags: null,
  title: null,
  modalIsOpen: false,
};

PodcastPage.propTypes = {
  author: PropTypes.string,
  description: PropTypes.string,
  episodes: PropTypes.array,
  error: PropTypes.bool,
  isComponentLoading: PropTypes.bool,
  labels: PropTypes.array,
  mainPodcastImage: PropTypes.object,
  modalIsOpen: PropTypes.bool,
  setModalClosed: PropTypes.func.isRequired,
  slug: PropTypes.string,
  tags: PropTypes.array,
  title: PropTypes.string,
};

export default PodcastPage;
